"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./_style.scss");

function DropdownOptionList(_ref) {
  var options = _ref.options,
      width = _ref.width,
      selectOption = _ref.selectOption,
      isOpen = _ref.isOpen,
      children = _ref.children,
      rest = _ref.rest;
  return isOpen ? /*#__PURE__*/_react["default"].createElement("div", Object.assign({
    className: "nstyle-dd__list",
    style: width
  }, rest), options.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "nstyle-dd__option-item",
      key: item.key,
      onClick: function onClick() {
        return selectOption(item);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "nstyle-dd__list-text"
    }, item.value));
  }), children) : null;
}

var _default = DropdownOptionList;
exports["default"] = _default;